module.exports = __webpack_public_path__ + "img/钻石.568805f9.png";